export enum BriefingReservedUrlAttributes {
    draftPublished,
    urlExpiry
}
